import { render, staticRenderFns } from "./VendorRegistration.vue?vue&type=template&id=6cae74f4&"
import script from "./VendorRegistration.vue?vue&type=script&lang=js&"
export * from "./VendorRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports